var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFront3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 44,
    height: 44,
    rx: 10,
    fill: "#FFE6C1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 6,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#F9C579"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9505 16.6113C12.0681 15.6251 11.6269 15.132 11.6103 14.713C11.5958 14.3489 11.7523 13.999 12.0332 13.767C12.3566 13.5 13.0183 13.5 14.3417 13.5H31.6584C32.9817 13.5 33.6434 13.5 33.9668 13.767C34.2478 13.999 34.4042 14.3489 34.3898 14.713C34.3731 15.132 33.9319 15.6251 33.0495 16.6114L26.3922 24.0518C26.2163 24.2484 26.1284 24.3467 26.0657 24.4586C26.0101 24.5578 25.9693 24.6646 25.9446 24.7756C25.9167 24.9008 25.9167 25.0327 25.9167 25.2965V31.5348C25.9167 31.7629 25.9167 31.877 25.8799 31.9756C25.8474 32.0628 25.7945 32.1409 25.7257 32.2034C25.6477 32.2742 25.5418 32.3166 25.33 32.4013L21.3633 33.988C20.9345 34.1595 20.7201 34.2453 20.548 34.2095C20.3975 34.1783 20.2654 34.0888 20.1805 33.9607C20.0834 33.8142 20.0834 33.5833 20.0834 33.1214V25.2965C20.0834 25.0327 20.0834 24.9008 20.0555 24.7756C20.0308 24.6646 19.99 24.5578 19.9344 24.4586C19.8717 24.3467 19.7837 24.2484 19.6078 24.0518L12.9505 16.6113Z",
    stroke: "#A26A1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFront3);
export default __webpack_public_path__ + "static/media/front-3.0a9a6c493ac09018c78b7b9994d34cdb.svg";
export { ForwardRef as ReactComponent };